import { Box, Flex, Text } from '@chakra-ui/react';
import React from 'react';

import { BorrowingBasePipelineSingleProgressBreakdownGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { VerificationStatusIcon } from './VerificationIcons';
import { colors } from 'packages/common-frontend/colors';
import { DataTapeErrorView } from 'packages/manualDataTapeUploads/ui/DataTapeErrorView';

export const VerificationProgressTracker: React.FC<{
  progressBreakdown: BorrowingBasePipelineSingleProgressBreakdownGQLType[];
}> = ({ progressBreakdown }) => {
  return (
    <Box>
      {progressBreakdown.map((breakdownStep) => (
        <Box key={breakdownStep.stepDescription}>
          <Flex mb="24px">
            <VerificationStatusIcon
              status={breakdownStep.status.status}
              my="auto"
              mr="8px"
            />
            <Text color={colors.gray[500]} my="auto">
              {breakdownStep.stepDescription}
            </Text>
          </Flex>
          {!!breakdownStep.status.errors && (
            <DataTapeErrorView
              errors={breakdownStep.status.errors}
              numOfRows={25}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};
